import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { action } from "typesafe-actions";
import { commonApi } from "../../api/talent/common-service";
import { AppState } from "../app-state";
import { CommonActionTypes } from "./common-types";
import Skill from "../../models/common/skill.model";


export const fetchExperienceTime = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CommonActionTypes.FETCH_EXPERIENCE_TIME));
        try {
            const response = await commonApi.fetchExperienceTime();
            dispatch(action(CommonActionTypes.FETCH_EXPERIENCE_TIME_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(CommonActionTypes.FETCH_EXPERIENCE_TIME_ERROR, error));
        }
    }
};

export const fetchDiversity = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CommonActionTypes.FETCH_DIVERSITY));
        try {
            const response = await commonApi.fetchDiversity();
            dispatch(action(CommonActionTypes.FETCH_DIVERSITY_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(CommonActionTypes.FETCH_DIVERSITY_ERROR, error));
        }
    }
};

export const fetchProficiency = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CommonActionTypes.FETCH_PROFICIENCY));
        try {
            const response = await commonApi.fetchProficiency();
            dispatch(action(CommonActionTypes.FETCH_PROFICIENCY_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(CommonActionTypes.FETCH_PROFICIENCY_ERROR, error));
        }
    }
};

export const fetchHireType = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CommonActionTypes.FETCH_HIRE_TYPE));
        try {
            const response = await commonApi.fetchHireType();
            dispatch(action(CommonActionTypes.FETCH_HIRE_TYPE_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(CommonActionTypes.FETCH_HIRE_TYPE_ERROR, error));
        }
    }
};

export const fetchDegree = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CommonActionTypes.FETCH_DEGREE));
        try {
            const response = await commonApi.fetchDegree();
            dispatch(action(CommonActionTypes.FETCH_DEGREE_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(CommonActionTypes.FETCH_DEGREE_ERROR, error));
        }
    }
};

export const fetchProfessionalMoment = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CommonActionTypes.FETCH_PROFESSIONAL_MOMENT));
        try {
            const response = await commonApi.fetchProfessionalMoment();
            dispatch(action(CommonActionTypes.FETCH_PROFESSIONAL_MOMENT_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(CommonActionTypes.FETCH_PROFESSIONAL_MOMENT_ERROR, error));
        }
    }
};

export const fetchAllSkills = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CommonActionTypes.FETCH_SKILL));
        try {
            const response = await commonApi.fetchAllSkills();
            const sortedData = response.data.sort((a: Skill, b: Skill) => a.name.localeCompare(b.name));
            dispatch(action(CommonActionTypes.FETCH_SKILL_SUCCESS, sortedData));
        } catch (error) {
            dispatch(action(CommonActionTypes.FETCH_SKILL_ERROR, error));
        }
    };
};

export const fetchCities = (name: string) => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CommonActionTypes.FETCH_CITY_DATA));
        try {
            const response = await commonApi.fetchCities(name);
            dispatch(action(CommonActionTypes.FETCH_CITY_DATA_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(CommonActionTypes.FETCH_CITY_DATA_ERROR, error));
        }
    }
};

export const fetchSignUpReasons = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(CommonActionTypes.FETCH_SIGNUP_REASONS));
        try {
            const response = await commonApi.fetchSignUpReasons();
            dispatch(action(CommonActionTypes.FETCH_SIGNUP_REASONS_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(CommonActionTypes.FETCH_SIGNUP_REASONS_ERROR, error));
        }
    }
};